module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Paul Souchet - Portfolio","short_name":"Paulfolio","lang":"fr","description":"vitrine des réalisations web de Paul Souchet","start_url":"/","background_color":"#000000","theme_color":"#2f3dff","display":"standalone","icon":"src/images/icon.png","orientation":"portrait","crossOrigin":"use-credentials","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","include_favicon":true,"cacheDigest":"27b76ebbcab99fe2c49f22af3baea749"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
